module.exports = __webpack_public_path__ + "assets/img/25.e3263d78.png";